<template>
  <BuilderBtnItem
    icon="cloud-upload-alt"
    title="Publish"
    :disabled="disabledPublish"
    :icon-size="iconSize"
    :button-state="buttonState"
    @click="publish"
  />
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderBtnItem from '@/components/builder/BuilderNav/BuilderBtnItem.vue'
import { postChangeCurrentVersion } from '@/api'
import { goToStudio } from '@/constants'
import { ButtonStates, ButtonState } from '@/types'
import { useBuilderStore } from '@/store/admin/builder'

const components = {
  BuilderBtnItem,
}

const props = {
  disabled: Boolean,
  iconSize: {
    type: String,
    default: '',
  },
}

@Component({ components })
export default class BuilderNavPublish extends Vue.extend({ props }) {
  builder = useBuilderStore()
  publishState: ButtonState = ButtonStates.ICON

  get savingState () {
    return this.builder.buttonState
  }

  get buttonState () {
    if (this.savingState === ButtonStates.PROCESSING) return this.savingState
    return this.publishState
  }

  get disabledPublish () {
    if (this.buttonState === ButtonStates.PROCESSING) return true
    return this.disabled || !this.canPublish
  }

  get canPublish () {
    return this.$typedStore.admin.userPermission.publish && (this.$typedStore.admin.userPermission.appLive || this.$typedStore.admin.userPermission.appInternal)
  }

  async save () {
    this.publishState = ButtonStates.PROCESSING
    return this.builder.save({
      saveSuccess: this.saveSuccess,
      saveFail: this.saveFail,
      imageUploadRequired: this.imageUploadRequired,
    })
  }

  saveSuccess () {
    this.$typedStore.primary.entities.nodes.resetNodeModifications()
    this.$analytics.event('save', {
      event_category: 'version-save',
      event_label: `version-${this.$route.params.primaryVersionId}`,
      event_result: 'success',
    })
  }

  saveFail () {
    this.$analytics.event('save', {
      event_category: 'version-save',
      event_label: `version-${this.$route.params.primaryVersionId}`,
      event_result: 'failure',
    })
    this.publishState = ButtonStates.ICON
  }

  imageUploadRequired () {
    this.$bvModal.show('SaveImageModal')
    this.$analytics.event('save', {
      event_category: 'version-save',
      event_label: `version-${this.$route.params.primaryVersionId}`,
      event_result: 'images',
    })
    this.publishState = ButtonStates.ICON
  }

  async publish () {
    const message = 'Publishing this version will save your settings and then update the live app immediately with this version. Do you wish to proceed?'
    const options = {
      title: 'Publish Version',
      okTitle: 'Publish',
      cancelTitle: 'Cancel',
    }
    if (await this.$bvModal.msgBoxConfirm(message, options) && await this.save()) {
      const versionId = Number(this.$router.currentRoute.params.primaryVersionId)
      const appId = Number(this.$route.params.primaryAppId)
      await postChangeCurrentVersion(versionId, {
        appId,
      })
      this.$analytics.event('publish', {
        event_category: 'version-action',
        event_label: `version-${versionId}`,
      })

      this.$typedStore.admin.navigation.setLeavePage(true)
      window.open(goToStudio(appId), '_self')
    }
  }
}

</script>
